import { render, staticRenderFns } from "./SavingsSimulatorPage.html?vue&type=template&id=0b690354&scoped=true&external"
import script from "./SavingsSimulatorPage.ts?vue&type=script&lang=ts&external"
export * from "./SavingsSimulatorPage.ts?vue&type=script&lang=ts&external"
import style0 from "./SavingsSimulatorPage.scss?vue&type=style&index=0&id=0b690354&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b690354",
  null
  
)

export default component.exports